import { CircularProgress, FormControl, FormLabel, Stack } from '@mui/material'
import { Controller, type ControllerProps } from 'react-hook-form'
import { LightButton, type LightsSelectorOption } from './LightButton'

export type LightsSelectorProps = {
    name: string
    label: string
    options?: LightsSelectorOption[]
    disabled?: boolean
    loading?: boolean
} & Omit<ControllerProps, 'render'>

const loadingLightsCount = 5

const LoadingLights = () => {
    return (
        <>
            {Array.from({ length: loadingLightsCount }).map((_, i) => (
                <LightButton key={`loadingLight${i}`} loading value="" avatar="" label="" />
            ))}
        </>
    )
}

export const LightsSelector = ({ name, label, options, disabled, loading, ...rest }: LightsSelectorProps) => {
    return (
        <Controller
            name={name}
            render={({ field }) => (
                <FormControl disabled={disabled}>
                    <FormLabel>
                        <Stack gap={1} direction="row" alignItems="center">
                            {label}
                            {loading && <CircularProgress size={12} />}
                        </Stack>
                    </FormLabel>

                    <Stack gap={1}>
                        {loading && !options ? (
                            <LoadingLights />
                        ) : (
                            options?.map((l) => {
                                const active = field.value === l.value
                                return (
                                    <LightButton
                                        key={l.value}
                                        disabled={disabled || loading}
                                        active={active}
                                        onClick={() => field.onChange(active ? '' : l.value)}
                                        {...l}
                                    />
                                )
                            })
                        )}
                    </Stack>
                </FormControl>
            )}
            {...rest}
        />
    )
}
